import React from 'react';
import { useParams } from 'react-router-dom';

import PageTemplate from '../../components/template/PageTemplate';
import EventSaveContainer from '../../views/event/save/EventSaveContainer';
import { EVENT_PAGE_NAME } from '../../constants/service/app/eventConstants';

const EventEdit = () => {
  const { id } = useParams();

  return (
    <PageTemplate pageName={EVENT_PAGE_NAME.EVENT_EDIT}>
      <EventSaveContainer key={id} />
    </PageTemplate>
  );
};

export default EventEdit;
